import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Radium from 'higher-order-components/configured-radium/'
import { Overlay, ColumnGroup, Column } from 'containers'
import { YoutubePlayer } from 'containers'

class VideoOverlay extends Component {
  static propTypes = {
    close: PropTypes.func,
    videoId: PropTypes.string
  }
  /**
   * @returns {ReactElement} React Component
   */
  render() {
    return (
      <Overlay close={this.props.close}>
        <ColumnGroup>
          <Column alignMiddle>
            <YoutubePlayer autoPlay videoId={this.props.videoId} />
          </Column>
        </ColumnGroup>
      </Overlay>
    )
  }
}

export default Radium(VideoOverlay)



// WEBPACK FOOTER //
// ./src/containers/video-overlay/index.jsx